// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__13sMM","resendInfoText":"OnGoingPaymentBox_resendInfoText__IIA6n"};